import type { CharacterSummary } from '../types';
import { classColor, factionColor, isStale } from '../lib/wow';

interface Props {
  char: CharacterSummary;
  /** Compact = small horizontal pill for the recent-activity strip. */
  compact?: boolean;
  onClick?: () => void;
}

function pretty(classFile: string): string {
  return classFile.charAt(0) + classFile.slice(1).toLowerCase();
}

function timeAgo(ms: number): string {
  const s = Math.floor((Date.now() - ms) / 1000);
  if (s < 60)    return `${s}s ago`;
  if (s < 3600)  return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function CharacterCard({ char, compact, onClick }: Props) {
  const color = classColor(char.classFile);
  const fc    = factionColor(char.faction);
  const stale = isStale(char.updatedAt);

  return (
    <button
      type="button"
      className={['char-card', compact ? 'char-card-compact' : '', stale ? 'is-stale' : ''].join(' ').trim()}
      style={{ borderLeftColor: color, '--char-class-color': color, '--char-faction-color': fc } as React.CSSProperties}
      onClick={onClick}
      title={`${char.name}-${char.realm} · ${pretty(char.classFile)} · L${char.level} · ${char.faction}`}
    >
      <div className="char-card-row1">
        <span className="char-card-name" style={{ color }}>{char.name}</span>
        {stale && <span className="chip stale">stale</span>}
      </div>
      <div className="char-card-row2">
        <span className="char-card-level">L{char.level}</span>
        <span className="char-card-class" style={{ color }}>{pretty(char.classFile)}</span>
        <span className="char-card-faction" style={{ color: fc }}>· {char.faction}</span>
      </div>
      {!compact && (
        <div className="char-card-row3">
          <span className="char-card-realm">{char.realm}</span>
          <span className="char-card-when">{timeAgo(char.updatedAt)}</span>
        </div>
      )}
    </button>
  );
}
